const introAnimation_lottieConfig = {
    container: document.getElementById("introAnim"), // the dom element that will contain the animation
    renderer: 'svg',
    loop: true,
    autoplay: true,
    name: "introAnim",
    path: '/wp-content/themes/millwrightprojects/assets/anim/animation.json' // the path to the animation json
}

lottie.loadAnimation(introAnimation_lottieConfig);